import"../../chunk-SDBWQ4EE.js";const a=(n,e,t)=>{let l;return(...u)=>{l==null&&(l=setTimeout(()=>{e.apply(n,u),l=null},t))}};export{a as throttle};
